import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';

import { styled } from '@mui/material/styles';
import {
  Typography,
  Divider,
  Stack,
  TextField,
  Button,
  Box,
  Step,
  StepLabel,
  Stepper,
} from "@mui/material";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

import pageTitle from "../../../utils/pageTitles.json";
import UsersListSvg from '../../../assets/svgs/usersList';
import { useLocation, useNavigate } from 'react-router-dom';
import FormProvider, { RHFTextField } from 'src/components/hook-form';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { axiosGetCall, axiosPostCall } from '../../../services/apisCall';
import { renderErrorMessage, renderSuccessMessage } from '../../../lib/toastMessage';
import { configFile, currentEnv } from 'src/config';

const currentEnv1 = currentEnv();
const queueEnvMapper = {
  local: 'devV2',
  dev: 'devV2',
  beta: 'betaV2',
  prod: 'v2',
};
const queueEnv = queueEnvMapper[currentEnv1] || queueEnvMapper.dev;



// home main section container.
const MainSection = styled('div')(() => ({
    padding: "64px 20px 0px 88px",
    backgroundColor: "rgb(240, 240, 240)"/* theme.palette.background.default */,
    height: '100vh',
    overflow: 'hidden'
}));

// Show home hading and filtes
const HeadingSection = styled('div')(() => ({
    width: '100%',
    padding: "20px 0px 20px 0px",
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row'
}));


const HeadingContentSection = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'row',
    gap: '15px',
    alignItems: 'center',
    justifyContent: 'center',
}));

const InputContainer = styled('div')(() => ({
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  gap: '20px',
}));

const steps = [
  {
    key: 'createGatewayQueue',
    name: 'createGatewayQueue',
    label: 'Create Gateway Queue',
    placeholder: 'Enter Create Gateway Queue.',
    apiName: 'createGatewayQueue',
    method: 'post',
  },
  {
    key: 'getfreeChannel',
    name: 'freeChannelApi',
    label: 'Free Channel Api',
    placeholder: 'Enter Free Channel Api.',
    apiName: 'getfreeChannel',
    method: 'get',
  },
  {
    key: 'calltestGAteway',
    name: 'testGatewayNumber',
    label: 'Number',
    placeholder: 'Enter Number.',
    apiName: 'calltestGAteway',
    method: 'post',
  },
];

const getStepColor = (status) => {
  if (status === 'completed') return '#50AB64';
  if (status === 'running') return '#1976d2';
  if (status === 'failed') return '#d32f2f';
  return '#9e9e9e';
};

const formatResponse = (response) => {
  if (!response) return '';
  if (typeof response === 'string') return response;
  return JSON.stringify(response, null, 2);
};

const toStringValue = (value) => {
  if (value === null || value === undefined) return '';
  return String(value);
};

const stringField = () =>
  Yup.string().transform((value, originalValue) => toStringValue(originalValue).trim());


const VoiceTestGateway = () => {
    const navigate = useNavigate();
    const [activeStep, setActiveStep] = useState(0);
    const [stepStatus, setStepStatus] = useState({
      createGatewayQueue: 'pending',
      getfreeChannel: 'pending',
      calltestGAteway: 'pending',
    });
    const [responses, setResponses] = useState({
      createGatewayQueue: '',
      getfreeChannel: '',
      calltestGAteway: '',
    });
    const [loading, setLoading] = useState(false);
    const [voiceHostInfo, setVoiceHostInfo] = useState(null);
    console.log("voiceHostInfo", voiceHostInfo);

    

        const { state } = useLocation();
        const userData = state?.userData;

          const Schema = Yup.object().shape({
            createGatewayQueue:
              activeStep === 0
                ? stringField().required('Create Gateway Queue is required!')
                : stringField(),
            freeChannelApi:
              activeStep === 1
                ? stringField().required('Free Channel Api is required!')
                : stringField(),
            testGatewayNumber:
              activeStep === 2
                ? stringField().required('Number is required!')
                : stringField(),
          });

          const methods = useForm({
            resolver: yupResolver(Schema),
            defaultValues: {
              createGatewayQueue: `${queueEnv}__${toStringValue(userData?.gateway_id)}`,
              freeChannelApi: '',
              testGatewayNumber: '',
            },
          });
        
          const { handleSubmit, setError, clearErrors, watch, setValue, } = methods;


    useEffect(() => {
        if (!userData) {
            navigate('/voiceGateway');
            return;
        }
    }, [navigate, userData]);
    useEffect(() => {
        getVoiceHostInfo();
    }, []);

    const getVoiceHostInfo = async () => {
        try {
            const response = await axiosGetCall('getVoiceHostInfo', { hostId: userData?.host_id });
            setVoiceHostInfo(response?.hostInfo);
            setValue('freeChannelApi', `${response?.hostInfo?.post_url}/sarvApiCps/calculateFreeChannelApiV1.php`);
        } catch (error) {
            renderErrorMessage(error?.message || 'Something went wrong while fetching voice host info');
        }
      }


    const updateStep = (key, status, response) => {
        setStepStatus((prev) => ({ ...prev, [key]: status }));
        if (response !== undefined) {
            setResponses((prev) => ({ ...prev, [key]: formatResponse(response) }));
        }
    };

    const handleResponseChange = (key, value) => {
        setResponses((prev) => ({ ...prev, [key]: value }));
    };

    const handleCopy = async (value) => {
        if (!value) return;
        try {
            await navigator.clipboard.writeText(value);
            renderSuccessMessage('Copied');
        } catch (error) {
            renderErrorMessage('Copy failed');
        }
    };

    const buildStepPayload = (currentStep, currentValue) => {
        if (currentStep.key === 'calltestGAteway') {
            return {
                gatewayId: userData?.gateway_id,
                mobileNo: currentValue,
            };
        }

        return {
            gatewayId: userData?.gateway_id,
        };
    };

    const resetFlowFromFirstStep = () => {
        setStepStatus({
            createGatewayQueue: 'pending',
            getfreeChannel: 'pending',
            calltestGAteway: 'pending',
        });
        setResponses({
            createGatewayQueue: '',
            getfreeChannel: '',
            calltestGAteway: '',
        });
    };

    const onSubmit = async (data) => {
        const currentStep = steps[activeStep];
        const currentValue = toStringValue(data[currentStep.name]).trim();

        if (!currentValue) {
            setError(currentStep.name, {
                type: 'manual',
                message: `${currentStep.label} is required!`,
            });
            return;
        }

        clearErrors(currentStep.name);

        const payload = buildStepPayload(currentStep, currentValue);

        setLoading(true);
        if (activeStep === 0) resetFlowFromFirstStep();
        updateStep(currentStep.key, 'running');

        try {
            const response = await axiosGetCall(currentStep.apiName, payload)

            updateStep(currentStep.key, 'completed', response);

            if (activeStep < steps.length - 1) {
                setActiveStep((prev) => prev + 1);
                renderSuccessMessage(`${currentStep.label} completed`);
            } else {
                renderSuccessMessage('Gateway test completed');
            }
        } catch (error) {
            updateStep(currentStep.key, 'failed', error?.message);
            renderErrorMessage(error?.message || 'Something went wrong');
        } finally {
            setLoading(false);
        }
    }


 

    return (
        <>
            <Helmet>
                <title> {`${pageTitle?.voiceGateways}`} </title>
            </Helmet>

            <MainSection>

                {/* Heading and filters */}
                <HeadingSection>
                    <HeadingContentSection>
                        <Box sx={{
                            widht: '16px',
                            height: '16px',
                            mt: "-10px",
                        }}>
                            <UsersListSvg />
                        </Box>
                        <Typography variant='h5' sx={{ color: 'grey.10', fontWeight: 600 }}>
                             Test Voice Gateways ({userData?.gateway_id})
                        </Typography>
                    </HeadingContentSection>
                    <Button
                        // startIcon={<PersonAddIcon />}
                        sx={{
                            backgroundColor: 'rgb(33, 43, 54)',
                            color: 'grey.100',
                            p: '0px 20px 0px 20px',
                            '&:hover': {
                                backgroundColor: 'rgb(69, 79, 91)'
                            }
                        }}
                        onClick={() => navigate('/voiceGateway')}
                    >
                        Gateways List
                    </Button>
                </HeadingSection>
{/* <BlankCard
  sx={{
    height: "100%",
    overflow: "auto",
  }}
> */}
<Box
  sx={{
    width: "100%",
    height: "87%",
    backgroundColor: "white",
    display: "flex",
    flexDirection: "row",
    overflow: "hidden",
    borderRadius: "4px",
  }}
>
  {/* Left Side */}
  <Box
    sx={{
      width: "40%",
      p: 3,
      display: "flex",
      flexDirection: "column",
      overflowY: "auto",
    }}
  >
    <Typography variant="h6" fontWeight={600} mb={2} sx={{color:"#212B36"}}>
      Gateway & Host Details
    </Typography>

    <Divider sx={{ mb: 2 }} />

    <Stack spacing={2}>
      <Typography><strong>Gateway ID:</strong> {userData?.gateway_id}</Typography>

      <Typography><strong>Gateway Name:</strong> {userData?.name}</Typography>

      <Typography><strong>Host ID:</strong> {userData?.host_id}</Typography>

      <Typography><strong>API Host:</strong> {voiceHostInfo?.post_url}</Typography>

      <Typography><strong>RM Host:</strong> {voiceHostInfo?.rabbit_mq_host}</Typography>

      <Typography><strong>RM Port:</strong> {voiceHostInfo?.rabbit_mq_port}</Typography>

      <Typography><strong>RM User:</strong> {voiceHostInfo?.rabbit_mq_user}</Typography>

      <Typography><strong>RM Password:</strong> {voiceHostInfo?.rabbit_mq_pass}</Typography>

      <Typography>
        <strong>Queue Create URL:</strong> {voiceHostInfo?.post_url}//sarvApiCps/calculateFreeChannelApiV1.php
      </Typography>

      <Typography>
        <strong>Sending Queue:</strong> QCallAdvanced_{queueEnv}__{userData?.gateway_id}
      </Typography>

      <Typography>
        <strong>Reporting Queue:</strong> QAdvancedReport_{queueEnv}__{userData?.gateway_id}
      </Typography>
    </Stack>
  </Box>

  {/* Vertical Divider */}
  <Divider orientation="vertical" flexItem />

  {/* Right Side */}
  <Box
    sx={{
      flex: 1,
      p: 3,
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
    }}
  >
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Box sx={{ height: "50%", minHeight: 260, display: "flex", flexDirection: "column" }}>
        <Typography variant="h6" fontWeight={600} mb={2}>
          Voice Test Form
        </Typography>

        <Divider sx={{ mb: 3 }} />

        <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 3 }}>
          {steps.map((step) => (
            <Step key={step.key} completed={stepStatus[step.key] === 'completed'}>
              <StepLabel
                sx={{
                  '& .MuiStepIcon-root': { color: getStepColor(stepStatus[step.key]) },
                  '& .MuiStepIcon-root.Mui-active': { color: getStepColor(stepStatus[step.key]) },
                  '& .MuiStepIcon-root.Mui-completed': { color: getStepColor(stepStatus[step.key]) },
                }}
              >
                {step.label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>

        <InputContainer>
          <RHFTextField
            name={steps[activeStep]?.name}
            label={steps[activeStep]?.label}
            placeholder={steps[activeStep]?.placeholder}
          />
        </InputContainer>

        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
          <Button
            type="submit"
            disabled={loading}
            sx={{
              backgroundColor: 'rgb(33, 43, 54)',
              color: 'grey.100',
              px: 3,
              '&:hover': { backgroundColor: 'rgb(69, 79, 91)' },
              '&.Mui-disabled': { color: 'grey.500' },
            }}
          >
            {loading ? 'Submitting...' : activeStep === steps.length - 1 ? 'Submit Test Gateway' : 'Submit & Next'}
          </Button>
        </Box>
      </Box>
    </FormProvider>

    <Divider sx={{ my: 2 }} />

    <Box sx={{ height: "50%", minHeight: 260, display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <Typography variant="h6" fontWeight={600} mb={2}>
        Response Board
      </Typography>

      <Stack spacing={2} sx={{ overflowY: "auto", pr: 1 }}>
        {steps.map((step, index) => (
          <Box key={step.key}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
              <Typography fontWeight={600}>{index + 1} Response</Typography>
              <Button
                size="small"
                startIcon={<ContentCopyIcon fontSize="small" />}
                onClick={() => handleCopy(responses[step.key])}
                disabled={!responses[step.key]}
              >
                Copy
              </Button>
            </Box>
            <TextField
              value={responses[step.key]}
              onChange={(event) => handleResponseChange(step.key, event.target.value)}
              placeholder={`${step.label} response`}
              multiline
              minRows={3}
              fullWidth
            />
          </Box>
        ))}
      </Stack>
    </Box>

  </Box>
</Box>
{/* </BlankCard> */}

            </MainSection>
           
        </>
    )
}


export default VoiceTestGateway;
